export default "__VITE_PUBLIC_ASSET__2f9f6fab__"